<template>
  <CockpitDialog
    :title="detailInfo.name"
    @close="$emit('close')"
    width="1000px"
    height="600px"
    top="175px"
    left="500px"
  >
    <div class="ql-editor text-white" v-html="detailInfo.content"></div>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'fileView',
  components: {
    CockpitDialog,
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
